import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import type { Client, Group } from '@/interfaces/client'

export const useClientStore = defineStore('client', () => {
    const clients = ref<Client[]>([])
    const currentClient = ref<Client>(
        window.localStorage.getItem('client')
            ? JSON.parse(window.localStorage.getItem('client') as string)
            : undefined
    )
    const defaultClient = ref<Client>(
        window.localStorage.getItem('default_client')
            ? JSON.parse(window.localStorage.getItem('default_client') as string)
            : undefined
    )

    const groups = ref<Group[]>(
        window.localStorage.getItem('groups')
            ? JSON.parse(window.localStorage.getItem('groups') as string)
            : []
    )
    const group = ref<Group|undefined>(
        window.localStorage.getItem('group')
            ? JSON.parse(window.localStorage.getItem('group') as string)
            : undefined
    )

    // Multi-select: array of selected groups (empty = all groups)
    const selectedGroups = ref<Group[]>(
        window.localStorage.getItem('selectedGroups')
            ? JSON.parse(window.localStorage.getItem('selectedGroups') as string)
            : []
    )

    function setClients(results: Client[]) {
        clients.value = results
    }
    function setCurrentClient(result: Client) {
        if (result != undefined) {
            window.localStorage.setItem('client', JSON.stringify(result))
        } else {
            window.localStorage.removeItem('client')
        }
        currentClient.value = result
    }
    function setDefaultClient(result: Client) {
        window.localStorage.setItem('default_client', JSON.stringify(result))
        defaultClient.value = result
    }
    function setGroups(results: Group[]) {
        if (results != undefined) {
            window.localStorage.setItem('groups', JSON.stringify(results))
        } else {
            window.localStorage.removeItem('groups')
        }
        groups.value = results
    }
    function setGroup(result: Group|undefined) {
        group.value = result
        if (result) {
            window.localStorage.setItem('group', JSON.stringify(result))
        } else {
            window.localStorage.removeItem('group')
        }
    }

    function setSelectedGroups(results: Group[]) {
        selectedGroups.value = results
        if (results.length > 0) {
            window.localStorage.setItem('selectedGroups', JSON.stringify(results))
        } else {
            window.localStorage.removeItem('selectedGroups')
        }
    }

    return {
        clients,
        currentClient,
        setClients,
        setCurrentClient,
        setDefaultClient,
        defaultClient,
        groups,
        group,
        setGroups,
        setGroup,
        selectedGroups,
        setSelectedGroups
    }
})
